import { render } from "./MainContents.vue?vue&type=template&id=1ad6ba2e"
import script from "./MainContents.vue?vue&type=script&lang=js"
export * from "./MainContents.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./MainContents.vue?vue&type=style&index=0&id=1ad6ba2e&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/home/circleci/project/frontend/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__